import { useEffect, useState } from "react";
import { api, API } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { FileSignature, Download } from "lucide-react";

export default function MeDocuments() {
  const [docs, setDocs] = useState([]);
  const [images, setImages] = useState({}); // path -> blob URL

  useEffect(() => {
    api.get("/me/documents").then(r => setDocs(r.data.documents || [])).catch(() => {});
  }, []);

  useEffect(() => {
    docs.forEach(d => {
      if (images[d.signature_path]) return;
      api.get(`/files/download`, { params: { path: d.signature_path }, responseType: "blob" })
        .then(r => setImages(prev => ({ ...prev, [d.signature_path]: URL.createObjectURL(r.data) })))
        .catch(() => {});
    });
    // eslint-disable-next-line
  }, [docs]);

  return (
    <div className="space-y-4" data-testid="me-documents">
      <div>
        <div className="text-xs uppercase tracking-widest text-neutral-500">Documents</div>
        <h1 className="text-3xl font-bold mt-1">Signed documents</h1>
        <p className="text-neutral-600 mt-1">Your legally-binding e-signatures and countersigned agreements.</p>
      </div>
      {docs.length === 0 && (
        <Card className="border-0 shadow-sm"><CardContent className="p-10 text-center text-neutral-500">
          No signed documents yet. Sign an e-signature task on the Home tab to see it here.
        </CardContent></Card>
      )}
      <div className="grid md:grid-cols-2 gap-4">
        {docs.map(d => (
          <Card key={d.task_id} className="border-0 shadow-sm" data-testid={`me-doc-${d.task_id}`}>
            <CardContent className="p-6">
              <div className="flex justify-between items-start">
                <div className="flex items-center gap-2">
                  <FileSignature className="w-4 h-4 text-pink" />
                  <div>
                    <div className="font-semibold">{d.title}</div>
                    <div className="text-xs text-neutral-500">Signed {new Date(d.signed_at).toLocaleString()}</div>
                  </div>
                </div>
                <Badge className="bg-teal text-white border-0">Signed</Badge>
              </div>
              <div className="mt-4 rounded-lg border p-3 bg-neutral-50 min-h-[100px] grid place-items-center">
                {images[d.signature_path] ? <img src={images[d.signature_path]} alt="Signature" className="max-h-24" /> : <span className="text-xs text-neutral-400">Loading signature…</span>}
              </div>
              <div className="text-xs text-neutral-500 mt-2">Signer: <span className="font-medium">{d.signer_name}</span></div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
